import React from 'react';
import { useScrollTrigger } from '@mui/material';
import PropTypes from 'prop-types';

// @desc MUI Native Customization for APPBAR effect
const ElevationScroll = (props) => {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
};
ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func,
};
export default ElevationScroll;
